export const SET_MEMBER_TYPE         = 'rtetest/SET_MEMBER_TYPE';
export const SET_MEMBERS             = 'rtetest/SET_MEMBERS';
export const SET_SELECTED_PAYER      = 'rtetest/SET_SELECTED_PAYER';
export const START_TEST              = 'rtetest/START_TEST';
export const CANCEL_TEST             = 'rtetest/CANCEL_TEST';
export const FETCH_MEMBERS           = 'rtetest/FETCH_MEMBERS';
export const FETCH_MEMBERS_FULFILLED = 'rtetest/FETCH_MEMBERS_FULFILLED';
export const FETCH_MEMBERS_FAILED    = 'rtetest/FETCH_MEMBERS_FAILED';
export const PERFORM_CHECK           = 'rtetest/PERFORM_CHECK';
export const PERFORM_CHECK_FULFILLED = 'rtetest/PERFORM_CHECK_FULFILLED';
export const PERFORM_CHECK_FAILED    = 'rtetest/PERFORM_CHECK_FAILED';

export function setMemberType(memberType) {
  return {
    type:    SET_MEMBER_TYPE,
    payload: memberType
  };
}

export function setMembers(members) {
  return {
    type:    SET_MEMBERS,
    payload: members
  };
}

export function setSelectedPayer(payerId) {
  return {
    type:    SET_SELECTED_PAYER,
    payload: payerId
  }
}

export function startTest(options) {
  return {
    type:    START_TEST,
    payload: options
  };
}

export function cancelTest() {
  return {
    type: CANCEL_TEST
  };
}

export function performCheck(testCase) {
  return {
    type:    PERFORM_CHECK,
    payload: testCase
  };
}

export function performCheckFulfilled(testCase) {
  return {
    type:    PERFORM_CHECK_FULFILLED,
    payload: testCase
  };
}

export function performCheckFailed(request, error) {
  return {
    type:    PERFORM_CHECK_FAILED,
    payload: { request, error }
  };
}

export function fetchMembers(options) {
  return {
    type:    FETCH_MEMBERS,
    payload: options
  };
}

export function fetchMembersFulfilled(members) {
  return {
    type:    FETCH_MEMBERS_FULFILLED,
    payload: members
  };
}

export function fetchMembersFailed(error) {
  return {
    type:    FETCH_MEMBERS_FAILED,
    payload: error
  };
}
